'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.siteHeaderComponent = undefined;

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var siteHeaderComponent = exports.siteHeaderComponent = {
    template: require('./site-header.html'),
    bindings: {
        navigationData: '<'
    },
    controllerAs: 'vm',
    controller: ["$scope", "$element", "$state", "$timeout", "config", "productService", "common", "exceptionService", "gettextCatalog", "authService", "dialogService", "ngDialog", "localizer", "reservationCampaignService", "Analytics", function controller(
    // $rootScope,
    $scope, $element, $state, $timeout, config,
    // ProductSearchRequest,
    // cartService,
    productService, common, exceptionService, gettextCatalog, authService, dialogService, ngDialog, localizer, reservationCampaignService, Analytics) {
        'ngInject';

        var vm = this;
        vm.name = '';
        vm.apbNumber = '';
        vm.tenantsCount = null;

        vm.toggleAccount = toggleAccount;
        vm.hideAccount = hideAccount;
        vm.showAccount = showAccount;
        vm.signOut = signOut;
        vm.changeTenant = changeTenant;

        vm.searchValue = '';
        vm.isLoading = false;
        vm.searchResults = null;
        vm.search = search;
        vm.searchIsOpen = false;
        vm.searchIsHovered = false;
        vm.showSearch = showSearch;
        vm.hideSearch = hideSearch;
        vm.onKeydownSearch = onKeydownSearch;
        vm.onMouseEnterSearchResults = onMouseEnterSearchResults;
        vm.selectedSearchResultIndex = -1;

        vm.currentLanguage = localizer.getCurrentLanguage();
        vm.setLanguage = setLanguage;
        vm.isFebelcoCustomer = isFebelcoCustomer;
        vm.checkVaccinDate = checkVaccinDate;

        vm.isShopAdmin = null;
        vm.selectTenant = selectTenant;
        vm.changeBuyerBase = changeBuyerBase;
        vm.changeSellerBuyerBase = changeSellerBuyerBase;
        vm.changeSeller = changeSeller;
        vm.vaccinesConfig = config.fluVaccines;
        vm.fluVaccinesEndDate = null;
        vm.fluVaccinesStartDate = null;

        vm.activeCampaigns = [];

        function checkVaccinDate() {
            vm.fluVaccinesEndDate = vm.vaccinesConfig.endDate;
            vm.fluVaccinesStartDate = vm.vaccinesConfig.startDate;
            return (0, _moment2.default)(vm.fluVaccinesStartDate).format('YYYY-MM-DD') <= (0, _moment2.default)().format('YYYY-MM-DD') && (0, _moment2.default)(vm.fluVaccinesEndDate).format('YYYY-MM-DD') >= (0, _moment2.default)().format('YYYY-MM-DD');
            // var today= moment().format('YYYY-MM-DD');
            // var startDate= moment('2020-03-16').format('YYYY-MM-DD');
            // var endDate = moment(config.vaccinesEndDate).format('YYYY-MM-DD');
            // var condition = startDate <= today && endDate >= today;
            // if (condition) {
            //     return true;
            // }
            // return false; //change to false to make this work
        }

        function setLanguage(language) {
            localizer.setLanguage(language);
            $state.go('.', {
                language: language
            });
        }

        function isFebelcoCustomer() {
            return authService.isFebelcoCustomer;
        }

        vm.preventDefault = function (e) {
            e.preventDefault();
        };
        vm.$onInit = init;

        function init() {
            var tenants = authService.customUserInfo.tenants;
            var activeTenant = tenants && tenants.find(function (t) {
                return !!t.secondaryAppUserKey && t.secondaryAppUserKey === authService.user.SAUK || !!t.id && t.id === parseInt(authService.user.BuyerID, 10);
            });
            if (!activeTenant) {
                $timeout(function () {
                    init();
                }, 100);
                return;
            }
            vm.name = authService.user.display_name;
            vm.tenantsCount = (tenants || []).length;
            if (activeTenant) {
                vm.apbNumber = activeTenant.apbNumber;
                vm.pharmacyName = activeTenant.name;
                vm.sellerName = activeTenant.sellerName;
                vm.canViewPackages = activeTenant.canViewPackages;
            }
            vm.isShopAdmin = authService.hasClaim('ShopAdmin');
            vm.isSeller = authService.isSeller;
            vm.isBuyer = authService.isBuyer;

            $element.find('.site-account a').on('click', function () {
                hideAccount();
            });

            if (isFebelcoCustomer()) {
                reservationCampaignService.getActiveReservationCampaigns().then(function (response) {
                    vm.activeCampaigns = response;
                });
            }
        }

        function toggleAccount() {
            angular.element('html').toggleClass('site-account-is-open');
        }

        function showAccount() {
            angular.element('html').toggleClass('site-account-is-open', true);
        }

        function hideAccount() {
            angular.element('html').toggleClass('site-account-is-open', false);
        }

        function signOut() {
            authService.signOut();
        }

        //tenant changed outside, update the tenant in menu
        $scope.$on('tenant-changed', function (event, args) {
            var tenants = authService.customUserInfo.tenants;
            var activeTenant = tenants && tenants.find(function (t) {
                return !!t.secondaryAppUserKey && t.secondaryAppUserKey === args.secondaryAppUserKey || !!t.id && t.id === parseInt(args.BuyerID, 10);
            });
            if (activeTenant) {
                vm.apbNumber = activeTenant.apbNumber;
                vm.pharmacyName = activeTenant.name;
                vm.sellerName = activeTenant.sellerName;
            }
        });

        function changeTenant() {
            return dialogService.selectTenant().then(function (tenant) {
                if (tenant.secondaryAppUserKey) {
                    vm.selectTenant(tenant.secondaryAppUserKey);
                    return tenant.secondaryAppUserKey;
                }
            }).then(function (secondaryAppUserKey) {
                var tenants = authService.customUserInfo.tenants;
                var activeTenant = tenants && tenants.find(function (t) {
                    return t.secondaryAppUserKey === secondaryAppUserKey;
                });
                if (activeTenant) {
                    vm.apbNumber = activeTenant.apbNumber;
                    vm.pharmacyName = activeTenant.name;
                    vm.sellerName = activeTenant.sellerName;
                }
            });
        }

        function selectTenant(tenant) {
            authService.signIn('/', { tenant: tenant }).catch(function () {
                common.log.warn('Signin with tenant failed');
            });
        }

        function changeBuyerBase() {
            ngDialog.openConfirm({
                template: '<buyer-base-select on-cancel="closeThisDialog($event)" on-confirm="confirm($event)"></buyer-base-select>',
                className: 'ngdialog ngdialog-theme-webshop',
                plain: true,
                showClose: true,
                closeByNavigation: true
            }).then(function (result) {
                vm.selectTenant(result.id);
                return result.id;
            }).then(function (id) {
                var tenants = authService.customUserInfo.tenants;
                var activeTenant = tenants && tenants.find(function (t) {
                    return t.id === id;
                });
                if (activeTenant) {
                    vm.apbNumber = activeTenant.apbNumber;
                    vm.pharmacyName = activeTenant.name;
                    vm.sellerName = activeTenant.sellerName;
                }
            });
        }

        function changeSellerBuyerBase() {
            ngDialog.openConfirm({
                template: '<buyer-base-select seller-id="' + authService.user.SellerID + '" on-cancel="closeThisDialog($event)" on-confirm="confirm($event)"></buyer-base-select>',
                className: 'ngdialog ngdialog-theme-webshop',
                plain: true,
                showClose: true,
                closeByNavigation: true
            }).then(function (result) {
                vm.selectTenant(authService.user.SAUK + ';' + result.id);
                return { buyerId: result.id, sauk: authService.user.SAUK };
            }).then(function (response) {
                var tenants = authService.customUserInfo.tenants;
                var activeTenant = tenants && tenants.find(function (t) {
                    return t.secondaryAppUserKey === response.sauk;
                });
                if (activeTenant) {
                    vm.apbNumber = activeTenant.apbNumber;
                    vm.pharmacyName = activeTenant.name;
                    vm.sellerName = activeTenant.sellerName;
                }
            });
        }

        function changeSeller() {
            return dialogService.selectTenant().then(function (tenant) {
                ngDialog.openConfirm({
                    template: '<buyer-base-select seller-id="' + tenant.sellerId + '" on-cancel="closeThisDialog($event)" on-confirm="confirm($event)"></buyer-base-select>',
                    className: 'ngdialog ngdialog-theme-webshop',
                    plain: true,
                    showClose: true,
                    closeByNavigation: true
                }).then(function (result) {
                    vm.selectTenant(tenant.secondaryAppUserKey + ';' + result.id);
                    return { buyerId: result.id, sauk: tenant.secondaryAppUserKey };
                }).then(function (response) {
                    var tenants = authService.customUserInfo.tenants;
                    var activeTenant = tenants && tenants.find(function (t) {
                        return t.secondaryAppUserKey === response.sauk;
                    });
                    if (activeTenant) {
                        vm.apbNumber = activeTenant.apbNumber;
                        vm.pharmacyName = activeTenant.name;
                        vm.sellerName = activeTenant.sellerName;
                    }
                });
            });
        }

        // Search

        function search() {
            common.log.info('go to search view from the search input box');

            if (vm.searchValue !== '') {
                $state.go('search', {
                    searchValue: vm.searchValue,
                    page: 1,
                    pageSize: 24,
                    sortProperty: '',
                    sortAsc: true
                });
                hideSearch();
            }
        }

        function showSearch() {
            vm.searchIsOpen = true;
            angular.element('html').toggleClass('locked site-search-is-open', true);
            angular.element('#search-input').find('input').focus();
        }

        function hideSearch() {
            vm.searchResults = null;
            vm.selectedSearchResultIndex = -1;
            vm.searchValue = '';

            vm.searchIsOpen = false;
            angular.element('html').toggleClass('locked site-search-is-open', false);
        }

        function onKeydownSearch() {
            //vm.showSearch();
            if (vm.searchResults && vm.searchResults.products) {
                if (event.keyCode === 40) {
                    // keyIdentifier = 'Down'
                    if (vm.selectedSearchResultIndex >= vm.searchResults.products.length) {
                        return;
                    }

                    vm.selectedSearchResultIndex++;
                } else if (event.keyCode === 38) {
                    // keyIdentifier = 'Up'
                    if (vm.selectedSearchResultIndex < 0) {
                        return;
                    }

                    vm.selectedSearchResultIndex--;
                } else if (event.keyCode === 13) {
                    // keyIdentifier = 'Enter'

                    if (!vm.searchResults || !vm.searchResults.products || vm.searchResults.products.length <= 0 || vm.selectedSearchResultIndex < 0 || vm.selectedSearchResultIndex > vm.searchResults.products.length) {
                        return;
                    }

                    if (vm.selectedSearchResultIndex === vm.searchResults.products.length) {
                        search();
                    } else {
                        var productId = vm.searchResults.products[vm.selectedSearchResultIndex].id;
                        common.log.info('go to product ' + productId + ' from search results');
                        $state.go('.product', {
                            productId: productId
                        });
                    }

                    vm.hideSearch();
                    event.preventDefault();
                    event.stopPropagation();
                    event.stopImmediatePropagation();
                }
            }
        }

        function onMouseEnterSearchResults(index) {
            vm.selectedSearchResultIndex = index;
        }

        $scope.$watch('vm.searchValue', function (newValue) {

            if (!newValue || newValue.length <= 2) {
                vm.searchResults = null;
                vm.selectedSearchResultIndex = -1;
                return;
            } else if (newValue && newValue.length > 2) {
                Analytics.trackPage('/search_results?q=' + newValue, 'send');
                Analytics.pageView();
            }

            vm.isLoading = true;
            common.log.info('search for ' + newValue);

            productService.searchProducts(newValue, 3).then(function (results) {
                Analytics.trackEvent('ProductSearch', 'siteHeaderSearch', newValue);
                vm.searchResults = results;
            }).catch(function () {
                exceptionService.logException(gettextCatalog.getString('The products cannot be retrieved.'));
            }).finally(function () {
                vm.isLoading = false;
            });
        });
    }]
};


//////////////////
// WEBPACK FOOTER
// ./features/layout/site-header.js
// module id = 942
// module chunks = 0